import { render, staticRenderFns } from "./Sftp.vue?vue&type=template&id=f8b73b62&scoped=true"
import script from "./Sftp.vue?vue&type=script&lang=js"
export * from "./Sftp.vue?vue&type=script&lang=js"
import style0 from "./Sftp.vue?vue&type=style&index=0&id=f8b73b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b73b62",
  null
  
)

export default component.exports